import * as tslib_1 from "tslib";
import { InputBase } from '../inputs/input-base/input-base';
/**
 * Base class for a string based field input component
 */
var InputStringBase = /** @class */ (function (_super) {
    tslib_1.__extends(InputStringBase, _super);
    function InputStringBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InputStringBase.prototype, "stringValue", {
        /**
         * Returns the value as casted as a string
         */
        get: function () {
            if (!this.value) {
                // Forcing empty string instead of null or undefined.
                // Solving problem with markdown compiler.
                return '';
            }
            return this.value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @returns A value indicating if the input has content and if it is valid
     */
    InputStringBase.prototype.hasValidContent = function () {
        if (this.stringValue.length === 0) {
            return false;
        }
        return this.isValidInput();
    };
    return InputStringBase;
}(InputBase));
export { InputStringBase };
